import { render } from "./WalletPage.vue?vue&type=template&id=614a5de0&ts=true"
import script from "./WalletPage.vue?vue&type=script&lang=ts"
export * from "./WalletPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__